"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Season = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const DateRange_1 = require("./DateRange");
const NumberRange_1 = require("./NumberRange");
const SeasonDay_1 = require("./SeasonDay");
// whitelist beats blacklist
let Season = class Season {
    dateRange;
    days = new Array();
    hoursWhitelist = new Array();
    hoursBlacklist = new Array();
    dateBlacklist = new Array(); // ignores year
    dateWhitelist = new Array(); // ignores year
};
exports.Season = Season;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => DateRange_1.DateRange),
    __metadata("design:type", DateRange_1.DateRange)
], Season.prototype, "dateRange", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => SeasonDay_1.SeasonDay),
    __metadata("design:type", Array)
], Season.prototype, "days", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => NumberRange_1.NumberRange),
    __metadata("design:type", Array)
], Season.prototype, "hoursWhitelist", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => NumberRange_1.NumberRange),
    __metadata("design:type", Array)
], Season.prototype, "hoursBlacklist", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Array)
], Season.prototype, "dateBlacklist", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Array)
], Season.prototype, "dateWhitelist", void 0);
exports.Season = Season = __decorate([
    (0, class_transformer_1.Exclude)()
], Season);
//# sourceMappingURL=Season.js.map